import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@shared/store/auth.store';
import { PATHS } from '@shared/router/paths';
import { RouteSplashScreen } from '@shared/router/RouteSplashScreen';

interface LocationState {
  from?: { pathname?: string };
}

/**
 * Inverse of ProtectedRoute: for auth-only pages (e.g. login). Already
 * authenticated users are redirected away — back to where they came from if
 * known, otherwise to the dashboard.
 */
export function PublicRoute() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isInitializing = useAuthStore((state) => state.isInitializing);

  if (isInitializing) {
    return <RouteSplashScreen />;
  }

  // `?add=1` is the Add Account flow: an already-signed-in user deliberately
  // opening the login form to add a second account, so it must not redirect.
  const addingAccount = new URLSearchParams(location.search).get('add') === '1';

  if (isAuthenticated && !addingAccount) {
    const state = location.state as LocationState | null;
    const redirectTo = state?.from?.pathname ?? PATHS.root;
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
